import { FunctionComponent, useCallback } from "react";
import { FieldProps } from "@animech/axiom-ui-builder";
import { TextBox } from "@animech/ui";
import * as Styled from "./decimal-input.style";
import { Root } from "@definitions";
import { useUiData } from "src/ui/data";

export type DecimalInputProps = FieldProps<Root> & {
	min?: number;
	max?: number;
	value?: string;
	id?: string;
};

export const DecimalInput: FunctionComponent<DecimalInputProps> = ({
	value,
	onValueChange,
	min,
	max,
	id,
}) => {
	const { localizer } = useUiData();

	const handleValueChange = useCallback(
		(value: string) => {
			try {
				const parsed = parseFloat(value);
				onValueChange?.(parsed);
			} catch (e) {
				// do nothing if number is invalid
			}
		},
		[onValueChange],
	);

	return (
		<Styled.CustomInputContainer
			label={id ? localizer.localizeUiNode(id) : undefined}
		>
			<TextBox
				type="number"
				step={0.01}
				min={min}
				max={max}
				onValueChange={handleValueChange}
				value={value}
			/>
		</Styled.CustomInputContainer>
	);
};
